import FeaturedNewsHero from "../../components/news/FeaturedNewsHero";
import TopStoriesRow from "../../components/news/TopStoriesRow";
import LatestNewsGrid from "../../components/news/LatestNewsGrid";
import EventSpotlight from "../../components/news/EventSpotlight";
import MiniRanking from "../../components/ranking/MiniRanking";
import SectionTitle from "../../components/common/SectionTitle";
import { mockEvents } from "../../data/mockEvents";
import { mockRanking } from "../../data/mockRanking";
import {mockArticles} from "../../data/mockNews";

export default function HomePage() {
    const featuredArticle = mockArticles.find((article) => article.featured) ?? mockArticles[0];
    const topStories = mockArticles.slice(0, 3);
    const latestArticles = mockArticles.slice(0, 6);
    const featuredEvent = mockEvents.find((event) => event.featured) ?? mockEvents[0];

    return (
        <div className="space-y-12 py-6 md:space-y-16">
            <FeaturedNewsHero article={featuredArticle} />

            <section>
                <SectionTitle title="À la une" />
                <TopStoriesRow articles={topStories} />
            </section>

            <section className="grid gap-8 xl:grid-cols-[1fr_360px]">
                <div>
                    <SectionTitle title="Dernières actualités" actionLabel="Voir toutes les actualités" />
                    <LatestNewsGrid articles={latestArticles} />
                </div>

                <div>
                    <MiniRanking rows={mockRanking} />
                </div>
            </section>

            <section>
                <SectionTitle title="Événement vedette" />
                <EventSpotlight event={featuredEvent} />
            </section>
        </div>
    );
}